import { Injectable } from '@angular/core';
import { HomeService } from './home.service';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';

type Tracker = {
  send: (
    hitType: string,
    category: string,
    action: string,
    label?: string
  ) => void;
};

declare const ga: {
  (...args: any[]): () => void;
  getAll: () => Tracker[];
};
declare var gtag;

const has = Object.prototype.hasOwnProperty;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  topArticleTitle :any;
  pathValue: string;
  mainValue: any;

  constructor(public router: Router, private homeService: HomeService,private authService: AuthenticationService) {
   }

   updatePageNameValue(){
    var pageTitles = this.homeService.getPageTitleValue() !== null ? JSON.parse(this.homeService.getPageTitleValue()) : null;
    var pageTitle ;
    if(pageTitles || this.topArticleTitle){
         
       console.log(window.location.pathname);
       
      switch(true){
       case (window.location.pathname.includes("/home")):  
         pageTitle = pageTitles.homePageTitle;
        break;
        case (window.location.pathname.includes("/login")):  
       console.log("Page title", pageTitles);
         pageTitle = pageTitles.loginPageTitle;
        break;
        case (window.location.pathname.includes("/survey")):  
         pageTitle = pageTitles.surveyPageTitle;
        break;
        case (window.location.pathname.includes("/helpcenter")):  
         pageTitle = pageTitles.myHelpCenterPageTitle;
        break;
        case (window.location.pathname.includes("/searchresults")):  
         pageTitle = "Search Results";
        break;
        case (window.location.pathname.includes("/helptopics") || window.location.pathname.includes("/browse") || 
              window.location.pathname.includes("/search") || window.location.pathname.includes("/kb")):  
          pageTitle = pageTitles.ghTitle;
        break;
        case (window.location.pathname.includes("/viewarticles")):  
         pageTitle = this.topArticleTitle;
        break;
        case (window.location.pathname.includes("/tracker")):  
        pageTitle = "Tracker";
        break;
      }
      return pageTitle;
    }
   }

   
  updatePageName(){
       var value = this.updatePageNameValue();
        if(value){
        this.setPageTitle(value);
     }
  }

  updateTileForKb(value){
    this.mainValue = value;
  }

  updateTileUrl(){
    if( window.location.search != "" && window.location.search != null && window.location.pathname.includes("searchresults")){
        let qValue = window.location.search.split('=')[1];
        let qValueSplit = qValue.split('&')[0];
        this.pathValue = window.location.pathname+'?q='+qValueSplit;
    }
    else if (window.location.pathname.includes("/article")) {
      let articleIDSplit = window.location.href.split('?')[1];
      this.pathValue = window.location.pathname+"/"+articleIDSplit+'?q='+this.mainValue;
    }
    else if (window.location.pathname.includes("/viewarticles")) {
      let articleIDSplit = window.location.href.split('?')[1];
      this.pathValue = window.location.pathname+"/"+articleIDSplit+'?q='+this.mainValue;
    }
    else if (window.location.pathname.includes("/survey")) {
      let surveyIDSplit = window.location.href.split('?')[1];
      this.pathValue = window.location.pathname+"/"+surveyIDSplit+'?q='+this.mainValue;
    }
    else{
      let pageTitle = this.updatePageNameValue();
      this.pathValue = window.location.pathname+'?q='+pageTitle;
    }
    return this.pathValue;
 }

 
  setPageTitle(value){
    this.updateTileForKb(value);
    document.title= value;
    console.log("Document value is ......",document.title);
    let initPage = localStorage.getItem("InitPage"+window.location.pathname.split("/")[2]);

   if(initPage === null || (initPage !== null && initPage !== window.location.pathname)){
     let url;
     if(window.location.pathname.includes("/survey")){
      url = window.location.pathname+window.location.search;
     }
     else{
       url = window.location.pathname;
     }
     this.logPageView(url, value);
   }
   else if(initPage !== null && initPage === window.location.pathname){
     localStorage.removeItem("InitPage"+window.location.pathname.split("/")[2]);
   }
  }

  logPageView(url: string, title:string) {
    console.log("Router..",this.router,"window location",window.location);
    console.log("logPageView",url)
    var urlValue  = this.updateTileUrl();
    if(url.length === 0){
      url = "shp"+this.router.url;
    }
    if (has.call(window, "ga")){
    ga(() => {
      if (has.call(window, "ga")) {
        ga("set", "page", url);
        if(!window.location.pathname.includes("/survey") ){
          ga("send", "pageview", urlValue);
         }
      }
    });
    gtag('event', 'page_view', {
      page_title: title,
      page_location: window.location.href,
      'debug_mode':true
    });
    }
  }
  setPageTitleForSurveyPage(){
    let pageTitle = JSON.parse(this.homeService.getPageTitleValue());
    this.setPageTitle(pageTitle.surveyPageTitle);
  }

}
